import { render, staticRenderFns } from "./PopUpPremium.vue?vue&type=template&id=5d8c3eb6"
import script from "./PopUpPremium.vue?vue&type=script&lang=js"
export * from "./PopUpPremium.vue?vue&type=script&lang=js"
import style0 from "./PopUpPremium.vue?vue&type=style&index=0&id=5d8c3eb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports